import { useState } from 'react';

import { useAppleStatusQuery } from 'apollo/queries/autogenerate/hooks';
import { AppleCreditStatus } from 'apollo/queries/autogenerate/schemas';
import useIsPlusUser from 'utils/hooks/use-is-plus-user';

export default function useIsPlusWithApple() {
  const { data: appleStatus } = useAppleStatusQuery({
    fetchPolicy: 'network-only',
  });
  const [loaded, setLoaded] = useState(false);

  const isPlusUser = useIsPlusUser({
    onCompleted() {
      setLoaded(true);
    },
  });

  return {
    isPlusWithApple:
      isPlusUser &&
      appleStatus?.appleCreditStatus.status === AppleCreditStatus.APPROVED,
    isLoaded: Boolean(appleStatus) && loaded,
  };
}
